import { render, staticRenderFns } from "./pedidoCard.vue?vue&type=template&id=5c03799c&scoped=true"
import script from "./pedidoCard.vue?vue&type=script&lang=js"
export * from "./pedidoCard.vue?vue&type=script&lang=js"
import style0 from "./pedidoCard.vue?vue&type=style&index=0&id=5c03799c&prod&lang=css"
import style1 from "./pedidoCard.vue?vue&type=style&index=1&id=5c03799c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c03799c",
  null
  
)

export default component.exports